"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerSupportSessionType = void 0;
var PartnerSupportSessionType;
(function (PartnerSupportSessionType) {
    PartnerSupportSessionType["general"] = "general";
    PartnerSupportSessionType["westCapitalLending"] = "westCapitalLending";
})(PartnerSupportSessionType || (exports.PartnerSupportSessionType = PartnerSupportSessionType = {}));
